// New Relic Browser Agent - Self-initializing module
// Import this file before anything else to ensure the agent loads first.
//
// Non-sensitive IDs are hardcoded per environment (they're visible in browser JS anyway).
// Only the license keys are injected via environment variables at build time.
//
// Required GitHub Secrets:
//   NEW_RELIC_LICENSE_KEY  - Ingest license key (from loader_config)
//   NEW_RELIC_BROWSER_KEY  - Browser-specific key starting with "NRBR-" (from info)

import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const licenseKey = process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || '';
const browserKey = process.env.REACT_APP_NEW_RELIC_BROWSER_KEY || '';
const environment = process.env.REACT_APP_ENVIRONMENT || 'dev';

const appConfig = {
    dev: {
        applicationID: '1120521721',
        agentID: '1120521721'
    },
    prd: {
        applicationID: '1120521742',
        agentID: '1120521742'
    }
};

const config = appConfig[environment] || appConfig.dev;

if (licenseKey && browserKey) {
    try {
        new BrowserAgent({
            init: {
                distributed_tracing: {
                    enabled: true
                },
                performance: {
                    capture_measures: true
                },
                privacy: {
                    cookies_enabled: true
                },
                ajax: {
                    deny_list: ['bam.nr-data.net']
                }
            },
            info: {
                beacon: 'bam.nr-data.net',
                errorBeacon: 'bam.nr-data.net',
                licenseKey: browserKey,
                applicationID: config.applicationID,
                sa: 1
            },
            loader_config: {
                accountID: '7595805',
                trustKey: '7595805',
                agentID: config.agentID,
                licenseKey: licenseKey,
                applicationID: config.applicationID
            }
        });
    } catch (error) {
        console.error('Failed to initialize New Relic Browser Agent:', error);
    }
}
